var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"spinner-border",class:{ 'spinner-border-sm': _vm.small },attrs:{"role":"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }